import { usePathname } from 'next/navigation';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useAppContext } from '../contexts/app';
import Main from './main';

const LoginRequired = () => {
  const { login } = useAppContext();
  const pathname = usePathname();

  return (
    <Main compact>
      <Typography variant="h1">Log in to continue</Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>Please log in to access this page.</Typography>

      <Button
        onClick={(e) => {
          e.preventDefault();
          login(pathname);
        }}
        variant="contained"
        color="primary"
        sx={{ my: 1, mb: 4 }}
      >
        Log In to Continue
      </Button>
    </Main>
  );
};

export default LoginRequired;
